package com.solevo.dist.application.models

import com.solevo.libraries.entities.logging.LogTypeBuilder
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.serialization.Serializable

enum class UserType {
    Contact, Supervisor, Cashier
}

enum class AllowPromotionalNotification(val status: Int) {
    NotSet(0),
    Accepted(1),
    Rejected(2)
}

enum class TermsConditionsSet(val status: Int) {
    NotSet(0),
    Accept(1),
    Reject(2)
}


data class User(
    val customerId: String = "",
    val firebaseUid: String = "",
    val contactId: String? = "",
    val legalEntityId: String? = null,
    val firstName: String = "",
    val lastName: String = "",
    var language: String = "",
    val phoneNumber: String = "",
    var pin: String? = null,
    val fcmToken: String? = null,
    val allowedCustomers: List<AllowedCustomer>? = null,
    val type: UserType? = UserType.Contact,
    //@get:PropertyName("isActive")
    val isActive: Boolean? = null,
    //@get:PropertyName("isManuallyImported")
    val isManuallyImported: Boolean? = null,
    val allowPromotionalNotifications: String? = AllowPromotionalNotification.NotSet.name
) {
    companion object {
        private val _customerIdFlow = MutableStateFlow("")
        val currentCustomerId = _customerIdFlow.asStateFlow()
        var userContactId: String? = ""
        var userCurrency: String = ""
        var language: String = "fr"
        var legalId: String = ""
        var userType: UserType = UserType.Contact
        var defaultWarehouseId: String? = null
        var customer: Customer? = null

        fun updateCustomerId(id: String) {
            _customerIdFlow.value = id
        }
        fun isLegalIdAngola(): Boolean {
            return legalId == ANGOLA_LEGAL_ENTITY_ID
        }
    }
}

@Serializable
data class AllowedCustomer(
    val name: String = "",
    val customerId: String = "",
    val legalEntityId: String? = null,
)

@Serializable
data class PromotionalNotificationConsentRequest(
    val userKey: UserKey? = null,
    val customerId: String = "",
    val allowPromotionalNotification: String? = null
)

@Serializable
data class CustomerKey(
    val legalEntityId: String? = null,
    val customerId: String? = null
)

@Serializable
data class UserKey(
    val legalEntityId: String? = null,
    val contactId: String?
)

const val ANGOLA_LEGAL_ENTITY_ID = "ao01"

class UserLogBuilder(
    val user: User?
): LogTypeBuilder.SpecificBuilder() {

    val data = payload

    init {
        add("firebase_uid", user?.firebaseUid ?: "unknown")
        add("customer_id", user?.customerId ?: "unknown")
        add("contact_id", user?.contactId ?: "unknown")
        add("legal_entity_id", user?.legalEntityId ?: "unknown")
        add("first_name", user?.firstName ?: "unknown")
        add("last_name", user?.lastName ?: "unknown")
        add("language", user?.language ?: "unknown")
        add("phone_number", user?.phoneNumber ?: "unknown")
        add("pin", user?.pin ?: "unknown")
        add("fcm_token", user?.fcmToken ?: "unknown")
        add("allowed_customers", user?.allowedCustomers?.toString() ?: "unknown")
        add("type", user?.type?.toString() ?: "unknown")
        add("is_active", user?.isActive?.toString() ?: "unknown")
        add("is_manually_imported", user?.isManuallyImported?.toString() ?: "unknown")
        add("allow_promotional_notifications", user?.allowPromotionalNotifications ?: "unknown")
    }
}